import React, { useState } from 'react'
import AgTechSideNavigationMenu from './Controls/AgTechSideNavigationMenu';
import AgTechSideNavigationMenuItem from './Controls/AgTechSideNavigationMenuItem';
import AgTechSideNavigationSubMenu from './Controls/AgTechSideNavigationSubMenu';
import { AgTechWebApplication } from '../../../../../application/AgTechWebApplication';

const AgTechStandardSidebarNavigation = (props: { app: AgTechWebApplication }) => {
    const [currentPath, setCurrentPath] = useState('/');
    const applicationAreas = props.app.structure.areas ?? [];

    return (
        <AgTechSideNavigationMenu
            app={props.app}
            content={isCollapsed => (
                <>
                    <AgTechSideNavigationMenuItem
                        text='Home'
                        icon='fas fa-home'
                        link='/home'
                        isCollapsed={isCollapsed}
                        onSelected={link => setCurrentPath(link)}
                        classes='h-[56px] leading-[56px] px-7 font-normal !mb-0'
                    />
                    {applicationAreas.map(area => area.workspaces.length > 1 ? (
                        <AgTechSideNavigationSubMenu
                            key={area.text}
                            text={area.text}
                            icon={area.icon}
                            isCollapsed={isCollapsed}
                            menuItems={area.workspaces.map(workspace => {
                                let workspacePath = `/${area.name}/${workspace.name}`;

                                return {
                                    text: workspace.text ?? workspace.name,
                                    link: workspacePath,
                                    isCollapsed: isCollapsed,
                                    onSelected: link => setCurrentPath(link)
                                };
                            })}
                        />
                    ) : (
                        <AgTechSideNavigationMenuItem
                            key={area.text}
                            text={area.text}
                            icon={area.icon}
                            isCollapsed={isCollapsed}
                            link={`/${area.name}`}
                            onSelected={link => setCurrentPath(link)}
                            classes='h-[56px] leading-[56px] px-7 !mb-0 font-normal'
                        />
                    ))}
                </>
            )}   
        />
    )
}

export default AgTechStandardSidebarNavigation;